import { PrintGroupByTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const PRINT_API_URL = 'OnHand/GetOnHandSummaryPrint';
export const PRINT_TRAN_DETAIL_URL = 'OnHand/GetOnHandTransactionDtlPrint';

export const printOptions = [
  { value: PrintGroupByTypeEnum.Item, label: 'Group By Item' },
  { value: PrintGroupByTypeEnum.Site, label: 'Group By Site' },
];



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/helper/onHand.js